
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-center",
      function () {
        return require("private-next-pages/user-center/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-center"])
      });
    }
  